import React from 'react';
import { BrowserRouter as Router, Route, Routes,  Navigate } from 'react-router-dom'
import Home from './pages/index';
import About from './pages/about';
import Team from './pages/team'
import Services from './pages/services'
import Contact from './pages/contact';
import Careers from './pages/career'

import Login from './dashboard/login'
import Dashboard from './dashboard/index'
import PrivateRoute from './dashboard/priavteLogin';

function Routers () {
    return (
      <Router>
           <Routes>
              <Route path="/" exact element={<Home/>}/>
              <Route path="/about-arkane" exact element={<About/>}/>
              <Route path="/arkane-services" exact element={<Services/>}/>
              <Route path="/arkane-career" exact element={<Careers/>}/>
              <Route path="/arkane-team" exact element={<Team/>}/>
              <Route path="/contact-arkane" exact element={<Contact/>}/>
              <Route path="/login" exact element={<Login/>}/>

                <Route
                    path="/arkane-job-crm"
                    element={
                        <PrivateRoute>
                          <Dashboard />
                        </PrivateRoute>
                    }/>

               <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
       </Router>
      )
}
export default Routers;